import { useAuth } from './use-auth';
import { Roles } from '@/lib/types';

export default function useIsUser() {
  const auth = useAuth();
  return auth.role && auth.role?.id === Roles.WorkspaceUser;
}
